import { useQuery } from '@tanstack/react-query';

import getOperatorPresence from 'Api/report-attendance-operator/getOperatorPresence';
import getOperatorPresenceRequest from './model/request/getOperatorPresenceRequest';
import getOperatorPresenceResponse from './model/response/getOperatorPresenceResponse';

const useGetOperatorPresence = (filter) => {
  return useQuery({
    queryKey: ['report-operator-presence', filter],
    queryFn: async () => {
      const queries = getOperatorPresenceRequest(filter);

      const response = await getOperatorPresence(queries);

      const result = getOperatorPresenceResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetOperatorPresence;
